<template>
  <div class="Banner wow bounceInDown">
    <div class="swiper-container" v-swiper:BannerSwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="bnnerImg">
            <img
              class="banner_bg"
              src="../../assets/img/index/banner_bg.png"
              alt="banner"
            />
            <div class="box_cont">
              <img
                class="wow bounceIn"
                data-wow-delay="0.5s"
                src="../../assets/img/index/banner_text.png"
                alt="banner"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoResize: true,
        watchActiveIndex: true,
        lazyLoading: true, // 图片懒加载
        lazyLoadingInPrevNext: true,
        preventLinksPropagation: false,
        preventClicks: false,
        visibilityFullFit: true,
        updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
        calculateHeight: true, // 当值为true时，
      },
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
    // new Swiper(".swiper-container", {
    //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //   observeParents: true, //修改swiper的父元素时，自动初始化swiper
    //   watchActiveIndex: true,
    //   lazyLoading: true, // 图片懒加载
    //   lazyLoadingInPrevNext: true,
    //   preventLinksPropagation: false,
    //   preventClicks: false,
    //   autoResize: true,
    //   visibilityFullFit: true,
    //   updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
    //   calculateHeight: true, // 当值为true时，
    // });
  },
};
</script>

<style lang="scss" scoped>
$minWidth: 1180px;
$minHeight: 700px;
.Banner {
  width: 100%;
  min-width: $minWidth;
  margin: 0 auto;
  .bnnerImg {
    width: 100%;
    min-width: $minWidth;
    margin: 0 auto;
    position: relative;
    .banner_bg {
      display: block;
      width: 100%;
      // height: $minHeight;
      object-fit: cover;
    }
    .box_cont {
      display: flex;
      justify-content: center;
      align-items: center;
      width: $minWidth;
      position: absolute;
      top: 90px;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 2;
    }
  }
}
</style>
